var render = function render(_c,_vm){return _c('div',_vm._g(_vm._b({class:[_vm.data.staticClass, 'v-divider', `v-divider--${_vm.props.direction}`]},'div',_vm.data.attrs,false),_vm.listeners),[(_vm.slots().default && _vm.props.direction !== 'vertical')?_c('div',{class:['v-divider__text', `is-${_vm.props.contentPosition}`]},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }